module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0156.jpg?v=5c2a9432";